// Here goes shared functions in all the app

/**
 * Convierte una cantidad de minutos a un texto legible en horas y minutos.
 * 45 -> "45 min" | 120 -> "2 h" | 90 -> "1 h 30 min"
 */
export const formatDurationFromMinutes = (totalMinutes) => {
  const total = Number(totalMinutes) || 0;
  const hours = Math.floor(total / 60);
  const minutes = total % 60;

  if (hours === 0) return `${minutes} min`;
  if (minutes === 0) return `${hours} h`;
  return `${hours} h ${minutes} min`;
};
